module.exports = __webpack_public_path__ + "img/45.2986f3c2.png";